import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users, ShieldCheck, LineChart, LogIn, Home, Play, Brain, RefreshCw } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useAssessmentStatus } from "@/hooks/useAssessmentStatus";
import ppuLogo from "@/assets/ppu-logo.png";

const Header = () => {
    const navigate = useNavigate();
    const { user, profile, isAdmin, logout } = useAuth();
    const { activeRun, latestAttempt, loading } = useAssessmentStatus();

    return (
        <div className="bg-card border-b border-border shadow-sm">
            <div className="container mx-auto px-4 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4 cursor-pointer" onClick={() => navigate('/')}>
                        <img src={ppuLogo} alt="PPU Logo" className="h-16 w-16 object-contain" />
                        <div>
                            <h1 className="text-lg font-bold text-foreground">Palestine Polytechnic University</h1>
                            <p className="text-sm text-muted-foreground font-tajawal" dir="rtl">جامعة بوليتكنك فلسطين</p>
                        </div>
                    </div>

                    {/* Login/Logout Section */}
                    <div className="flex items-center gap-3">
                        {user ? (
                            <>
                                <span className="text-sm text-muted-foreground hidden md:inline-block">
                                    <span className="font-bold">Welcome,</span> <span className="font-bold text-foreground">{profile?.first_name || user.email}</span>
                                </span>

                                <Button variant="outline" size="sm" onClick={() => navigate('/')} className="gap-2">
                                    <Home className="h-4 w-4" />
                                    <span className="hidden md:inline">Home</span>
                                </Button>
                                <Button variant="outline" size="sm" onClick={() => navigate('/dashboard')} className="gap-2">
                                    <LayoutDashboard className="h-4 w-4" />
                                    <span className="hidden md:inline">Dashboard</span>
                                </Button>
                                <Button variant="outline" size="sm" onClick={() => navigate('/profile')} className="gap-2">
                                    <Users className="h-4 w-4" />
                                    <span className="hidden md:inline">Profile</span>
                                </Button>
                                <Button variant="outline" size="sm" onClick={() => navigate('/analytics')} className="gap-2">
                                    <LineChart className="h-4 w-4" />
                                    <span className="hidden md:inline">Analytics</span>
                                </Button>
                                {isAdmin && (
                                    <>
                                        <Button variant="outline" size="sm" onClick={() => navigate('/admin')} className="gap-2">
                                            <ShieldCheck className="h-4 w-4" />
                                            <span className="hidden md:inline">Admin</span>
                                        </Button>
                                    </>
                                )}
                                <Button variant="outline" size="sm" onClick={logout}>
                                    Logout
                                </Button>
                            </>
                        ) : (
                            <Button variant="outline" size="sm" onClick={() => navigate('/login')}>
                                <LogIn className="h-4 w-4 mr-2" />
                                Login
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
